<template>
  <div>
    <el-button type="primary" @click="addCompany" icon="el-icon-plus">添加公司</el-button>
     <el-table
        v-loading="loading"
        :data="list"
        style="width: 100%">
        <el-table-column
          prop="company_id"
          label="#"
          width="180">
        </el-table-column>
        <el-table-column
          label="Logo"
          width="180">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.company_logo"
              style="width: 60px; height: 60px"
              :src="scope.row.company_logo"
              fit="fill"></el-image>
            <div style="width: 60px;height:60px;line-height: 60px;text-align: center; font-size: 28px; color: #ccc;" v-else>
              <i class="el-icon-picture"></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="company_name"
          label="公司名称">
        </el-table-column>
        <el-table-column
          label="其他信息"
          >
          <template slot-scope="scope">
            <el-button @click="handleOpen(1, scope.row)" type="text" size="small">慈善</el-button>
            <el-button @click="handleOpen(2, scope.row)" type="text" size="small">荣誉</el-button>
            <el-button @click="handleOpen(3, scope.row)" type="text" size="small">资质特权</el-button>
          </template>
        </el-table-column>
        <el-table-column
        fixed="right"
        label="操作"
        width="100">
          <template slot-scope="scope">
            <el-button @click="editCompany(scope.row)" type="text" size="small">编辑</el-button>
            <el-button style="color: #F56C6C;" @click="deleteCompany(scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        :title="actionname"
        :visible.sync="centerDialogVisible"
        @open="companyname = ''"
        @close="resetForm"
        width="50%"
       >
        <el-form ref="form" :model="form" label-width="160px">
          <el-form-item label="LOGO">
            <el-upload
              class="avatar-uploader"
              action="/api/commons/upload/uploadimg"
              :data="{format:'file', file_type:'company'}"
              :show-file-list="false"
              :on-success="handleLOGOSuccess"
              :before-upload="beforeLOGOUpload">
              <img v-if="form['row[company_logo]']" :src="form['row[company_logo]']" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="营业执照">
            <el-upload
              class="avatar-uploader"
              action="/api/commons/upload/uploadimg"
              :data="{format:'file', file_type:'company'}"
              :show-file-list="false"
              :on-success="handleBusinessSuccess"
              :before-upload="beforeLOGOUpload">
              <img v-if="form['row[business_img]']" :src="form['row[business_img]']" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="公司名称">
            <el-input v-model="form['row[company_name]']" placeholder="请输公司名称"></el-input>
            <!-- <el-select
              v-model="form['row[company_name]']"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="getcompany"
              :loading="getcompanyloading">
              <el-option
                v-for="item in companylist"
                :key="item.id"
                :label="item.company_name"
                :value="item.id">
              </el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="公司法人">
            <el-input v-model="form['row[legal_person]']" placeholder="请输公司法人"></el-input>
          </el-form-item>
          <el-form-item label="公司成立时间">
            <el-date-picker type="date" placeholder="选择日期" v-model="form['row[company_begin_date]']"></el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="所属行业">
            <el-input v-model="form['row[company_industry]']" placeholder="请输公司所属行业"></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="公司性质">
            <el-input v-model="form['row[compay_nature]']" placeholder="请输公司经营性质"></el-input>
          </el-form-item> -->
          <el-form-item label="公司电话">
            <el-input v-model="form['row[company_phone]']" placeholder="请输公司常用电话/手机/座机"></el-input>
          </el-form-item>
          <el-form-item label="公司网站">
            <el-input v-model="form['row[site]']" placeholder="请输公司官网地址 http[s]://"></el-input>
          </el-form-item>
          <el-form-item label="公司邮箱">
            <el-input v-model="form['row[company_email]']" placeholder="请输常用邮箱"></el-input>
          </el-form-item>
          <el-form-item label="公司邮编">
            <el-input v-model="form['row[company_zipcode]']" placeholder="请输公司邮编"></el-input>
          </el-form-item>
          <el-form-item label="省市县/区">
            <el-cascader
                :value="[form['row[company_province_id]'],form['row[company_city_id]'],form['row[company_county_id]']]"
                @change="cascaderchange"
                :options="area"></el-cascader>
          </el-form-item>
          <el-form-item label="详细地址">
            <el-input v-model="form['row[company_address]']" placeholder="街道/楼层/门牌号"></el-input>
          </el-form-item>
          <el-form-item label="主营业务">
            <el-input v-model="form['row[main_business]']" placeholder="请输主营业务"></el-input>
          </el-form-item>
          <el-form-item label="公司联系人">
            <el-input v-model="form['row[contact_name]']" placeholder="请输公司联系人姓名"></el-input>
          </el-form-item>
          <el-form-item label="公司联系人职务">
            <el-input v-model="form['row[contact_position]']" placeholder="请输公司联系人职务"></el-input>
          </el-form-item>
          <el-form-item label="公司联系人电话">
            <el-input v-model="form['row[contact_phone]']" placeholder="请输公司联系人电话"></el-input>
          </el-form-item>
          <el-form-item label="雇员人数">
            <el-input v-model="form['row[employees_number]']" type="number" placeholder="请输公司雇员人数"></el-input>
          </el-form-item>
          <el-form-item label="公司职务">
            <el-input v-model="form['row[company_position]']" placeholder="请输您在该公司的职务"></el-input>
          </el-form-item>
          <el-form-item label="公司党组织职务">
            <el-input v-model="form['row[company_patry_position]']" placeholder="请输您在该公司党组织职务"></el-input>
          </el-form-item>
          <el-form-item label="五证合一码">
            <el-input v-model="form['row[company_code]']" placeholder="请输公司五证合一码"></el-input>
          </el-form-item>
          <el-form-item label="注册资金[单位万元]">
            <el-input v-model="form['row[register_money]']" placeholder="请输公司注册资金 单位万元"></el-input>
          </el-form-item>
          <el-form-item label="资产合计[单位万元]">
            <el-input v-model="form['row[total_money]']" placeholder="请输公司总资产价值 单位万元"></el-input>
          </el-form-item>
          <el-form-item label="年销售额[单位万元]">
            <el-input v-model="form['row[income_money]']" placeholder="请输公司年销售收入 单位万元"></el-input>
          </el-form-item>
          <el-form-item label="是否存在党组织">
            <el-switch active-value="Y" inactive-value="N" v-model="form['row[party_organiztion_exist]']"></el-switch>
          </el-form-item>
          <el-form-item label="是否存在团组织">
            <el-switch active-value="Y" inactive-value="N" v-model="form['row[group_organiztion_exist]']"></el-switch>
          </el-form-item>
          <el-form-item label="是否存在工会">
            <el-switch active-value="Y" inactive-value="N" v-model="form['row[company_union_exist]']"></el-switch>
          </el-form-item>
          <el-form-item>
            <el-button v-loading="sendCompanyLoading" type="primary" @click="sendCompanyInfo">保存</el-button>
            <el-button @click="centerDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
        <!-- <div slot="footer" class="dialog-footer">
          <el-button v-loading="sendCompanyLoading" type="primary" @click="sendCompanyInfo">确 定</el-button>
        </div> -->
      </el-dialog>
      <el-drawer
        :destroy-on-close="true"
        size="470px"
        :with-header="false"
        :visible="drawer"
        :direction="direction"
        @close="handleClose">
        <companycharitable v-if="openType==1" :company_id="company_id"></companycharitable>
        <companyhonor v-if="openType==2" :company_id="company_id"></companyhonor>
        <companyqualifications v-if="openType==3" :company_id="company_id"></companyqualifications>
      </el-drawer>
  </div>
</template>

<script>
  import { mapState } from "vuex";
  import $http from "../../../request.js";
  import moment from "moment";
  import companyhonor from "./companyhonor.vue";
  import companycharitable from "./companycharitable.vue";
  import companyqualifications from "./companyqualifications.vue";
  export default{
    name: "company",
    components:{
      companyhonor,
      companycharitable,
      companyqualifications
    },
    data(){
      return {
        company_id: "",
        direction: 'rtl',
        drawer:false,
        actionname:"添加公司",
        actiontype: 1, // 1 添加公司， 2 编辑公司
        companylist: [],
        companyname: "",
        loading: false,
        list: [],
        centerDialogVisible: false,
        sendCompanyLoading: false,
        getcompanyloading: false,
        openType: 1,
        form: {
          'row[company_logo]': '',
          'row[company_name]': '',
          'row[company_phone]': '',
          'row[site]': '',
          'row[company_email]': '',
          'row[company_zipcode]': '',
          'row[company_address]': '',
          'row[company_province_id]': '',
          'row[company_city_id]': '',
          'row[company_county_id]': '',
          'row[main_business]': '',
          'row[contact_name]': '',
          'row[contact_position]': '',
          'row[contact_phone]': '',
          'row[legal_person]': '',
          'row[employees_number]': '',
          'row[company_code]': '',
          'row[register_money]': '',
          'row[total_money]': '',
          'row[income_money]': '',
          'row[company_begin_date]': '',
          'row[company_industry]': '',
          'row[compay_nature]': '',
          'row[party_organiztion_exist]': '',
          'row[group_organiztion_exist]': '',
          'row[company_union_exist]': '',
          'row[company_position]': '',
          'row[is_master]': '',
          'row[business_img]': '',
          'row[company_patry_position]': ''
        }
      };
    },
    computed:{
      ...mapState([
        "area"
      ])
    },
    created(){
      this.getlist();
    },
    methods:{
      handleOpen(type, row) {
        this.company_id = row.company_id;
        this.openType = type;
        this.drawer = true;
      },
      handleClose() {
        this.drawer = false;
      },
      resetForm(){
        this.form = {
          'row[company_logo]': '',
          'row[company_name]': '',
          'row[company_phone]': '',
          'row[site]': '',
          'row[company_email]': '',
          'row[company_zipcode]': '',
          'row[company_address]': '',
          'row[company_province_id]': '',
          'row[company_city_id]': '',
          'row[company_county_id]': '',
          'row[main_business]': '',
          'row[contact_name]': '',
          'row[contact_position]': '',
          'row[contact_phone]': '',
          'row[legal_person]': '',
          'row[employees_number]': '',
          'row[company_code]': '',
          'row[register_money]': '',
          'row[total_money]': '',
          'row[income_money]': '',
          'row[company_begin_date]': '',
          'row[company_industry]': '',
          'row[compay_nature]': '',
          'row[party_organiztion_exist]': '',
          'row[group_organiztion_exist]': '',
          'row[company_union_exist]': '',
          'row[company_position]': '',
          'row[is_master]': '',
          'row[business_img]': '',
          'row[company_patry_position]': ''
        };
      },
      deleteCompany(row){
        this.$confirm('此操作将永久删除该内容, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          $http.post("/api/company/member_company/del", {
            company_id: row.company_id
          }).then(res=>{
            if(res.data.code==1){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.list = this.list.filter(v=>v.company_id!=row.company_id);
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      },
      cascaderchange(values){
        this.form['row[company_province_id]'] = values[0];
        this.form['row[company_city_id]'] = values[1];
        this.form['row[company_county_id]'] = values[2];
      },
      handleLOGOSuccess(res) {
        if(res.code==1) {
          this.form['row[company_logo]'] = res.data;
        } else {
          this.$message.error(res.msg);
        }
      },
      handleBusinessSuccess(res) {
        if(res.code==1) {
          this.form['row[business_img]'] = res.data;
        } else {
          this.$message.error(res.msg);
        }
      },
      beforeLOGOUpload(file) {
        const isJPG = ['image/jpeg', 'image/png'].includes(file.type);
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }else if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      sendCompanyInfo(){
        this.sendCompanyLoading = true;
        let url = "/api/company/member_company/add";
        if(this.actiontype==2){
          url = "/api/company/member_company/newEdit";
        }
        let params = {
          ...this.form
        };
        params['row[company_begin_date]'] = moment(params['row[company_begin_date]']).format('YYYY-MM-DD');
        
        if(params['row[company_begin_date]'] == 'Invalid date'){
          params['row[company_begin_date]'] = "";
        }
        
        $http.post( url, params)
        .then(res=>{
          this.sendCompanyLoading = false;
          if(res.data.code==1){
            this.getlist();
            this.centerDialogVisible = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });
          }
        })
        .catch(err=>{
          this.sendCompanyLoading = false;
          console.log(err);
        });
      },
      getcompany(keyword){
        if (!keyword) return false;
        this.getcompanyloading = true;
        $http.post("/api/company/company/searchByCompanyName",{
          company_name: keyword
        })
        .then(res=>{
          this.getcompanyloading = false;
          this.companylist = res.data.data;
        });
      },
      addCompany(){
        this.centerDialogVisible = true;
        this.actionname = "添加公司";
        this.actiontype = 1;
      },
      editCompany(row){
        const loading = this.$loading({
          lock: true,
          text: 'Loading'
        });
        $http.post("/api/company/member_company/myCompanyDetail",{
          company_id: row.company_id
        })
          .then(res=>{
            this.loading = false;
            loading.close();
            this.centerDialogVisible = true;
            this.actionname = "编辑公司";
            this.actiontype = 2;
            console.log(this.form);
            this.form['row[company_id]'] = "";
            for(let key in res.data.data) {
              if(['company_province_id', 'company_city_id', 'company_county_id'].includes(key)){
                this.form['row['+key+']'] = res.data.data[key].toString();
              } else if(typeof this.form['row['+key+']'] !== 'undefined'){
                this.form['row['+key+']'] = res.data.data[key];
              }
            }
          })
        
      },
      handleClick(row){
        console.log(row);
      },
      getlist(){
        this.loading = true;
        $http.post("/api/company/member_company/getNewList")
          .then(res=>{
            this.loading = false;
            if (res.data.code==1){
              this.list = res.data.data;
            }
          })
          .catch(err=>{
            console.log(err);
            this.loading = false;
          });
      },
    }
  }
</script>

<style lang="less" scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
  }
  .avatar {
    width: 120px;
    height: 120px;
    display: block;
  }
</style>
